import { render, staticRenderFns } from "./PptRichTextAttr.vue?vue&type=template&id=1f3b86db&"
import script from "./PptRichTextAttr.vue?vue&type=script&lang=js&"
export * from "./PptRichTextAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3b86db')) {
      api.createRecord('1f3b86db', component.options)
    } else {
      api.reload('1f3b86db', component.options)
    }
    module.hot.accept("./PptRichTextAttr.vue?vue&type=template&id=1f3b86db&", function () {
      api.rerender('1f3b86db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/PptRichTextAttr.vue"
export default component.exports